import {
  INSTALMENT_RATE,
  MeetingStatus,
  PREMIUM_MEETING_STATUS,
} from 'constants/adviser';
import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';
import { LIFE_REFERRAL_ITEMS } from 'constants/marketScan';
import { IAdviserConnect } from 'types';

export const isReferralAdviserConnect = (ad: IAdviserConnect) =>
  (R.includes(ad.meetingStatus, PREMIUM_MEETING_STATUS) &&
    !ad.policyProvider) ||
  ad.policyProvider?.includes('Get Advice');

export const getPremiumAdviserConnect = (
  adviserConnects: IAdviserConnect[] = [],
) => {
  return adviserConnects.find(isReferralAdviserConnect) || null;
};

export const getInstalmentAmount = (amount: number) => {
  return (amount * INSTALMENT_RATE) / 11;
};

export const showMarketScanResultsPage = (meetingStatus: string) => {
  return R.includes(meetingStatus, [
    MeetingStatus.CLIENT_ACTION_AWAITING_ACCEPTANCE,
    MeetingStatus.ADVISER_ACTION_CONFIRM_ACCEPTANCE,
  ]);
};

export const getAdviserPolicies = (policyTypes: string[]) => {
  const filtered = policyTypes.filter((policyType) =>
    LIFE_REFERRAL_ITEMS.some(R.propEq('title', policyType)),
  );
  const toReduce =
    filtered.length > 0 ? filtered : [INSURANCE_TYPES_NAMES.LIFE];
  return toReduce.reduce((acc, policyType) => R.assoc(policyType, 1, acc), {});
};
